module.exports = __webpack_public_path__ + "91b0bdbe8508264f1ca981462fe0a243.pdf";